// extracted by mini-css-extract-plugin
module.exports = {"guide":"IndexGuidePortal-module--guide--_lkgY","guideWrapper":"IndexGuidePortal-module--guideWrapper--2I4JA","symbol":"IndexGuidePortal-module--symbol--3hBU5"};